<div class="row mt-5">
  <p class="h3 text-center">{{ message | async }}</p>
</div>
